module.exports = __webpack_public_path__ + "static/media/a-warm-winter-night.11820b6c.jpg";